import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './ModalBody.module.scss';

type Props = React.PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    topDivider?: boolean;
    bottomDivider?: boolean;
  }
>;

export default function ModalBody({
  children,
  className,
  topDivider = true,
  bottomDivider = true,
  ...props
}: Props): JSX.Element {
  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.topDivider]: topDivider,
          [styles.bottomDivider]: bottomDivider,
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
